"use client";

import {
  WHATSAPP_SECTIONS,
  WHATSAPP_TAGS,
} from "@/@core/enums/whatsapp_tags.enum";
import { useVenueDetail } from "@/hooks/venueContext";
import { cn } from "@/lib/utils";
import useWhatsappContext from "@/hooks/useWhatsappContext";
import WhatsappLinkWithBeacon from "@/components/WhatsappLinkWithBeacon";
import useGetWpHref from "@/hooks/useGetWpHref";
import { Container } from "@/components/ui/container";
import convertNewLinesToBr from "@/lib/convert-new-lines-to-br";
import WhatsappIcon from "@/components/hero-icons/whatsapp-icon";
import { useTranslation } from "@/hooks/translationContext";

interface Props {
  title: string;
  description: string;
  phone: string;
  percent: number;
}

export default function DiscountCardBody(props: Props) {
  const { t } = useTranslation();
  const { venue } = useVenueDetail();
  const whatsappContext = useWhatsappContext();

  const translateValues = whatsappContext.getContext({
    venue: venue?.descriptions?.[0]?.title,
    "discount-visitors": props?.percent,
  });

  const getWhatsappHrefUrl = useGetWpHref();

  return (
    <div className="w-full min-h-[198px] !max-h-[280px] !h-auto p-2 bg-white rounded-[32px] border border-gray-200 flex-col justify-start items-start gap-2 inline-flex">
      <div className="w-full  p-4 bg-white rounded-3xl border-dashed border border-slate-300 justify-start gap-4 flex">
        <div className="w-[80px] h-[136px] p-2 bg-white rounded-2xl border border-slate-300 flex-col justify-center items-center inline-flex">
          <span className={cn("text-slate-800 text-3xl font-bold")}>
            %{props.percent}
          </span>
          <span className="text-slate-800 text-sm font-bold">İndirim</span>
        </div>

        <div className="flex justify-between flex-col xl:w-[277.5px] w-full">
          <h3
            className="line-clamp-[5] max-md:line-clamp-[6] text-ellipsis overflow-hidden text-slate-800 text-xs md:text-sm font-medium"
            dangerouslySetInnerHTML={{
              __html: convertNewLinesToBr(props.description),
            }}
          />

          <div className="flex justify-end items-end">
            <WhatsappLinkWithBeacon
              section={WHATSAPP_SECTIONS.DISCOUNT}
              venueId={venue?.id}
              title={t("venue-detail-ask-discount-button")}
              disabled={!props.phone}
              href={getWhatsappHrefUrl({
                phone: props.phone,
                tag: WHATSAPP_TAGS.DISCOUNT,
                translateValues,
              })}
            >
              <Container
                disabled={!props.phone}
                className="!h-6"
                variant="assistant"
              >
                <WhatsappIcon className="size-4" />
                <span className="text-center  text-sm font-bold">
                  İndirim Sor
                </span>
              </Container>
            </WhatsappLinkWithBeacon>
          </div>
        </div>
      </div>
    </div>
  );
}
